var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
var STORE_PATHNAME_HANDLERS = [
    function (update, pathnameHistory) {
        if (update.action === 'PUSH' && update.location.pathname.includes('/sheet')) {
            return { key: 'STORE', update: { pathnameHistoryKey: '/sheet', pathname: update.location.pathname } };
        }
        if (update.action === 'REPLACE' && update.location.pathname === '/sheet' && pathnameHistory['/sheet']) {
            return {
                key: 'CURRENT',
                update: {
                    url: '#' + pathnameHistory['/sheet'],
                    current: __assign(__assign({}, update), { location: __assign(__assign({}, update.location), { pathname: pathnameHistory['/sheet'] }) }),
                },
            };
        }
    },
    function (update, pathnameHistory) {
        if (update.action === 'PUSH' && update.location.pathname.includes('/dashboard')) {
            return { key: 'STORE', update: { pathnameHistoryKey: '/dashboard', pathname: update.location.pathname } };
        }
        if (update.action === 'REPLACE' && update.location.pathname === '/dashboard' && pathnameHistory['/dashboard']) {
            return {
                key: 'CURRENT',
                update: {
                    url: '#' + pathnameHistory['/dashboard'],
                    current: __assign(__assign({}, update), { location: __assign(__assign({}, update.location), { pathname: pathnameHistory['/dashboard'] }) }),
                },
            };
        }
    },
    function (update, pathnameHistory) {
        if (update.action === 'PUSH' && update.location.pathname.includes('/database')) {
            return { key: 'STORE', update: { pathnameHistoryKey: '/database', pathname: update.location.pathname } };
        }
        if (update.action === 'REPLACE' && update.location.pathname === '/database' && pathnameHistory['/database']) {
            return {
                key: 'CURRENT',
                update: {
                    url: '#' + pathnameHistory['/database'],
                    current: __assign(__assign({}, update), { location: __assign(__assign({}, update.location), { pathname: pathnameHistory['/database'] }) }),
                },
            };
        }
    },
    function (update, pathnameHistory) {
        if (update.action === 'PUSH' && update.location.pathname.includes('/import')) {
            return { key: 'STORE', update: { pathnameHistoryKey: '/import', pathname: update.location.pathname } };
        }
        if (update.action === 'REPLACE' && update.location.pathname === '/import' && pathnameHistory['/import']) {
            return {
                key: 'CURRENT',
                update: {
                    url: '#' + pathnameHistory['/import'],
                    current: __assign(__assign({}, update), { location: __assign(__assign({}, update.location), { pathname: pathnameHistory['/import'] }) }),
                },
            };
        }
    },
];
export function CustomHashRouter(props) {
    var basename = props.basename, children = props.children, hashHistory = props.hashHistory;
    var _a = __read(useState({
        action: hashHistory.action,
        location: hashHistory.location,
    }), 2), current = _a[0], setCurrent = _a[1];
    var _b = __read(useState({
        '/sheet': undefined,
        '/import': undefined,
        '/dashboard': undefined,
        '/database': undefined,
    }), 2), pathnameHistory = _b[0], setPathnameHistory = _b[1];
    useLayoutEffect(function () {
        var unlisten = hashHistory.listen(function (update) {
            var e_1, _a, _b;
            try {
                for (var STORE_PATHNAME_HANDLERS_1 = __values(STORE_PATHNAME_HANDLERS), STORE_PATHNAME_HANDLERS_1_1 = STORE_PATHNAME_HANDLERS_1.next(); !STORE_PATHNAME_HANDLERS_1_1.done; STORE_PATHNAME_HANDLERS_1_1 = STORE_PATHNAME_HANDLERS_1.next()) {
                    var pathnameHandler = STORE_PATHNAME_HANDLERS_1_1.value;
                    var data = pathnameHandler(update, pathnameHistory);
                    if ((data === null || data === void 0 ? void 0 : data.key) === 'STORE') {
                        setPathnameHistory(__assign(__assign({}, pathnameHistory), (_b = {}, _b[data.update.pathnameHistoryKey] = data.update.pathname, _b)));
                        break;
                    }
                    if ((data === null || data === void 0 ? void 0 : data.key) === 'CURRENT') {
                        history.pushState(data.update.current.location.state, '', data.update.url);
                        setCurrent(data.update.current);
                        return;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (STORE_PATHNAME_HANDLERS_1_1 && !STORE_PATHNAME_HANDLERS_1_1.done && (_a = STORE_PATHNAME_HANDLERS_1.return)) _a.call(STORE_PATHNAME_HANDLERS_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            setCurrent(update);
        });
        return function () {
            unlisten();
        };
    }, [hashHistory, pathnameHistory]);
    return (React.createElement(Router, { basename: basename, location: current.location, navigator: hashHistory, navigationType: current.action }, children));
}
